// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".article-box[data-v-d4d404e0] {\n  width: 100%;\n}\n.article-box .el-pagination[data-v-d4d404e0] {\n  margin-top: 20px;\n}\n.article-box .quill-editor[data-v-d4d404e0] {\n  height: 300px;\n  margin-bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
